// extracted by mini-css-extract-plugin
export default {"loader":"loader-rkiIaTZKe3_WsbV_yJbX","rotation":"rotation-mzPl3pMRGvH5ZQnQu7qS"};